// typings

import { create } from "zustand";
import { persist } from "zustand/middleware";

import { IRemessasEnAndamentoState } from "@/store-zustand/cliente/remessas-em-andamento/index.d";

// criação da store com Zustand (Remessas em Andamento)
export const useStoreZustandRemessaEmAndamento = create<IRemessasEnAndamentoState>()(
  persist(
    (set) => ({
      // estados
      isLoading: false,
      isModalSolicitacaoRemessa: false,
      paginations: [1],
      itemsPerPage: 5,
      currentPage: 1,
      totalItemsPage: 0,
      searchItem: "",
      lastPage: 0,
      remessaEmAndamentoUnico: null,

      // ações
      setIsLoading: (isLoading) => set({ isLoading }),
      setItemsPerPage: (itemsPerPage) => set({ itemsPerPage }),
      setCurrentPage: (currentPage) => set({ currentPage }),
      setTotalItemsPage: (totalItemsPage) => set({ totalItemsPage }),
      setSearchItem: (searchItem) => set({ searchItem }),
      setLastPage: (lastPage) => set({ lastPage }),
      setPaginations: (paginations) => set({ paginations }),

      setRemessaEmAndamentoUnico: (remessaEmAndamentoUnico) => set({ remessaEmAndamentoUnico }),

      clearPersistedData: () =>
        set({
          remessaEmAndamentoUnico: null, // limpar apenas o remessaEmAndamentoUnico
        }),
    }),
    {
      name: "store-remessa-em-andamento", // nome da chave no localStorage
      partialize: (state) => ({
        remessaEmAndamentoUnico: state.remessaEmAndamentoUnico, // persistir apenas o remessaEmAndamentoUnico
      }),
    }
  )
);
